module.exports = __webpack_public_path__ + "static/bill-ad3ee03a133c8b706fd85892536f525e.jpg";